import { render, staticRenderFns } from "./newsSidebar.vue?vue&type=template&id=7e321c9f&scoped=true"
import script from "./newsSidebar.vue?vue&type=script&lang=js"
export * from "./newsSidebar.vue?vue&type=script&lang=js"
import style0 from "./newsSidebar.vue?vue&type=style&index=0&id=7e321c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e321c9f",
  null
  
)

export default component.exports